/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NullableRangeDtoFromJSON, NullableRangeDtoToJSON, } from './NullableRangeDto.js';
/**
 * Check if a given object implements the CreateCompanyForEmployerCompanyDto interface.
 */
export function instanceOfCreateCompanyForEmployerCompanyDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('locationId' in value) || value['locationId'] === undefined)
        return false;
    if (!('employeeCount' in value) || value['employeeCount'] === undefined)
        return false;
    return true;
}
export function CreateCompanyForEmployerCompanyDtoFromJSON(json) {
    return CreateCompanyForEmployerCompanyDtoFromJSONTyped(json, false);
}
export function CreateCompanyForEmployerCompanyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'locationId': json['locationId'],
        'employeeCount': NullableRangeDtoFromJSON(json['employeeCount']),
    };
}
export function CreateCompanyForEmployerCompanyDtoToJSON(json) {
    return CreateCompanyForEmployerCompanyDtoToJSONTyped(json, false);
}
export function CreateCompanyForEmployerCompanyDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'locationId': value['locationId'],
        'employeeCount': NullableRangeDtoToJSON(value['employeeCount']),
    };
}
